import { useState } from "react";
import CountryValidation from "./CountryValidation";

const GuestCheckoutForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    country: null,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = { ...formData, countryName: formData.country.name };
    // console.log(data);
    onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit} className="mt-6 space-y-4">
      <CountryValidation
        value={formData.country}
        onChange={(country) => setFormData((prev) => ({ ...prev, country }))}
      />
      <input
        type="email"
        required
        placeholder="Email address"
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        className="w-full px-3 py-2 rounded-lg bg-gray-800 text-white border border-gray-700"
      />

      <input
        type="tel"
        required
        placeholder="Phone number"
        value={formData.phone}
        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
        className="w-full px-3 py-2 rounded-lg bg-gray-800 text-white border border-gray-700"
      />

      <button
        type="submit"
        disabled={!formData.country}
        className={`w-full py-2 rounded-lg font-semibold transition ${
          formData.country
            ? "bg-yellow-500 hover:bg-yellow-600 text-black"
            : "bg-gray-700 text-gray-400 cursor-not-allowed"
        }`}
      >
        Continue to Payment
      </button>
    </form>
  );
};

export default GuestCheckoutForm;
